module.exports = __webpack_public_path__ + "img/fr.3186537f.svg";